import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtils } from '../http-utils';
import { URL_BASE } from '../../core/constants';
import { GeocodingResult } from '../geocoding-result.model';
import { Latng } from '../latng';
import { Address } from '../address.model';
import { map } from 'rxjs/operators';
import { ReverseGeocodingResult } from '../reverse-geocoding-result.model';

@Injectable()
export class GeocodingService {

  private GEOCODING_URI = 'routing/geocoding';

  constructor(private http: HttpClient) {
  }

  public geocode(q: string): Observable<GeocodingResult> {
    const headers = HttpUtils.createHeaders();

    return this.http.get<GeocodingResult>(`${URL_BASE}/api/${this.GEOCODING_URI}`, { headers })
  }

  public reverseGeocode(latng: Latng): Observable<Address> {
    const headers = HttpUtils.createHeaders();

    const params = {
      latitude: String(latng.latitude),
      longitude: String(latng.longitude),
    };

    return this.http.get(`${URL_BASE}/api/${this.GEOCODING_URI}/reverse`, { headers, params })
      .pipe(
        map(result => ReverseGeocodingResult.fromDto(result)),
        map(result => Address.fromCmblAddress(result.result, latng)),
      );
  }
}
